import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar, MatDialog } from '@angular/material';
import { Router } from '@angular/router';

const apiURL = environment.apiURL;

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  constructor(private http: HttpClient, private snackBar: MatSnackBar, private router: Router, private dialog: MatDialog) { }

  getProducts() {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/products/query`, {});
  }

  getLeaves() {
    const data = new FormData();
    data.append('category', 'Leaves');

    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/products/query/`, data);
  }

  getDressings() {
    const data = new FormData();
    data.append('category', 'Dressings');
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/products/query/`, data);
  }

  getProductsAsAdmin() {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/products/query/admin`, {});
  }

  getProductsAsAdminForBasket() {
    const data = new FormData();
    data.append('enable', 'true')

    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/products/query/admin`, data);
  }

  getProductAsAdmin(data) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/products/query/admin`, data);
  }

  createProduct(data) {
    this.http.post<{ success: boolean, data: any }>(`${apiURL}/products`, data).subscribe(result => {
      if (result.success) {
        this.router.navigate(['/admin/products']);
        this.snackBar.open('Product successfully added', 'Dismiss', {
          duration: 3000
        })
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      })
    });
  }

  updateProduct(data) {
    this.http.put<{ success: boolean, data: any }>(`${apiURL}/products/`, data).subscribe(result => {
      if (result.success) {
        this.router.navigate(['/admin/products']);
        this.snackBar.open('Produdct successfully updated', 'Dismiss', {
          duration: 3000
        })
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      })
    })
  }

  deleteProduct(ID) {
    const data = new FormData();
    data.append('_id', ID);

    this.http.request<{ success: boolean, data: any }>('delete', `${apiURL}/products`, { body: data }).subscribe(result => {
      if (result.success) {
        this.router.navigate(['/admin/products']);
        this.dialog.closeAll();
        this.snackBar.open('Produdct successfully deleted', 'Dismiss', {
          duration: 3000
        });
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  deleteBasket(ID) {
    const data = new FormData();
    data.append('_id', ID);

    this.http.request<{ success: boolean, data: any }>('delete', `${apiURL}/baskets`, { body: data }).subscribe(result => {
      if (result.success) {
        this.router.navigate(['/admin/baskets']);
        this.dialog.closeAll();
        this.snackBar.open('Basket successfully deleted', 'Dismiss', {
          duration: 3000
        });
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      })
    });
  }
}
